import { ObserveVisibility  } from 'vue-observe-visibility'

export default {
    install: function (Vue) {
        Vue.directive('observe-visibility', ObserveVisibility)
    }
}